import { inject } from "@angular/core";
import { Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { Observable, of, EMPTY, forkJoin } from "rxjs";
import { map, mergeMap, take } from "rxjs/operators";
import { LANDING_ROUTE } from "src/app/app-routing.module";
import {CompetitorResultsService, PublicEventsService} from "@services";
import {
  CategoryItem,
  CompetitorFilter,
  CompetitorResults,
  EventItem,
  EventStatus,
  PagedFilter,
  Pages
} from "@model";

export const EventDetailsPublicResolver: ResolveFn<Observable<EventItem | null> |
  Promise<EventItem> | EventItem> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   publicEventsService: PublicEventsService = inject(PublicEventsService),
   router: Router = inject(Router))
    : Observable<EventItem | null> |
    Promise<EventItem> | EventItem => {
    let eventId = route.queryParams["eventId"];
    if (!eventId) {
      router.navigate([LANDING_ROUTE]);
      return EMPTY;
    } else {
      return publicEventsService.findEventById(eventId)
        .pipe(
          take(1),
          mergeMap((res: EventItem | null) => {
            if (res) {
              return of(res);
            } else {
              router.navigate([LANDING_ROUTE]);
              return EMPTY;
            }
          })
        );
    }
  }

export const EventDetailsHolderPublicResolver: ResolveFn<Observable<EventDetailsHolder | null> |
  Promise<EventDetailsHolder> | EventDetailsHolder> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   publicEventsService: PublicEventsService = inject(PublicEventsService),
   competitorResultsService: CompetitorResultsService = inject(CompetitorResultsService),
   router: Router = inject(Router))
    : Observable<EventDetailsHolder | null> |
    Promise<EventDetailsHolder> | EventDetailsHolder => {
    let eventId = route.queryParams["eventId"];
      if (!eventId) {
      router.navigate([LANDING_ROUTE]);
      return EMPTY;
    } else {
      return publicEventsService.findEventById(eventId)
        .pipe(
          mergeMap((eventItem: EventItem | null) => {
            if (eventItem) {
              if ((eventItem?.racesList?.length ?? 0) > 0) {
                let competitorFilter: CompetitorFilter = new CompetitorFilter();
                competitorFilter.raceId = eventItem.racesList![0].id;
                competitorFilter.eventId = eventItem.id;

                return forkJoin({
                  results: competitorResultsService.getCompetitorResults(new PagedFilter(new Pages(), competitorFilter)),
                  categories: competitorResultsService.findCategoryItemsByRaceId(eventItem.racesList![0].id!)
                }).pipe(
                  map(({ results, categories }) => ({
                    eventItem: eventItem,
                    results: results,
                    categories: categories
                  }))
                );

              } else {
                return of({ eventItem: eventItem, results: [], categories: [] });
              }
            } else {
              router.navigate([LANDING_ROUTE]);
              return EMPTY;
            }
          })
        );
    }
  }

export interface EventDetailsHolder {
  eventItem: EventItem;
  results: CompetitorResults[];
  categories: CategoryItem[];
}
